import { ChangeEvent, FC, useContext } from 'react';
import { css } from '@emotion/css';
import { Checkbox } from '@chakra-ui/react';
import colors from '@prezzee/ribbon-ui/lib/theme/foundations/colors';

import { ItemType } from './SelectFilter';
import { DrainContext } from '../../contexts/DrainContext';

const Styles = {
  container: css`
    display: flex;
    flex-direction: column;
    margin: 15px 16px 25px 0;
    padding: 0 0 2px 16px;
    max-height: 288px;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background-color: ${colors.gray[100]};
      border-radius: 2px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: ${colors.purple[400]};
      border-radius: 2px;
    }
  `,

  checkbox: css`
    margin: 21px 0 0;

    &:first-child {
      margin: 0;
    }
  `,

  label: css`
    font-size: 14px;
    line-height: 14px;
  `,
};

interface Props {
  items: ItemType[];
  itemsStatus: {
    [uid: string]: boolean;
  };
  onChange: (e: ChangeEvent<HTMLInputElement>, codename: string, name: string) => void;
  title: string;
  parentCodename: string;
}

const SelectFilterCheckboxGroup: FC<Props> = ({ items, itemsStatus, onChange, title, parentCodename }) => {
  const drain = useContext(DrainContext);

  return (
    <div className={Styles.container}>
      {items.map(({ codename, name }) => (
        <Checkbox
          size={'lg'}
          key={codename}
          name={name}
          className={Styles.checkbox}
          isChecked={itemsStatus[codename]}
          onChange={e => {
            drain.appendFilter({
              codename,
              name,
              parent: {
                parent: void 0,
                name: title,
                codename: parentCodename,
              },
            });
            onChange(e, codename, name);
          }}
          isFocusable={false}
        >
          <span className={Styles.label}>{name}</span>
        </Checkbox>
      ))}
    </div>
  );
};

export default SelectFilterCheckboxGroup;
